<template>
  <div class="home filterGray">
    <top-navigation ref="topNav"
                    :navBg="navBg"
                    :isHome="true"></top-navigation>
    <!-- 轮播图 -->
    <div :style="{'min-width': '1200px','display': 'flex','justify-content': 'center','background-color':bg}">
      <div class="swpier">
        <el-carousel height="450px"
                     :initial-index="initialIndex"
                     @change="initialIndexChange"
                     :autoplay="true">
          <el-carousel-item v-for="(item,index) in swiperList"
                            :key="index">
            <el-image v-if="item.resourceType == 1"
                      @click="$Public.link(item)"
                      style="width:1200px;height: 450px;cursor: pointer;"
                      :src="item.resourceUrl + '?imageMogr2/thumbnail/100000000@'"
                      alt=""></el-image>
            <video v-if="item.resourceType == 2"
                   class="video"
                   :controls="false"
                   :autoplay="true"
                   :src="item.resourceUrl"></video>
          </el-carousel-item>
        </el-carousel>
      </div>
    </div>
    <!-- 我能为你做什么 -->
    <div class="doWhat_box">
      <!-- :style="{'backgroundImage':'url(' + $imgUrl+ 'home/bg.gif)','backgroundSize':'100% 100%' ,'backgroundRepeat': 'no-repeat'}" -->
      <video class="video"
             playsinline
             webkit-playsinline
             :loop="true"
             muted
             :controls="false"
             :autoplay="true"
             :src="$imgUrl + 'home/官网背景_batch.mp4'"></video>
      <div class="totalList">
        <div class="currency_box totalbox">
          <div class="total_item"
               v-for="(item,index) in numberList"
               :key="index">
            <div>
              <count-to :startVal='0'
                        class="num"
                        :endVal='item.num'
                        :duration='3000'></count-to>
              {{index==0?'年':'+'}}
            </div>
            <div>{{item.text}}</div>
          </div>
        </div>
      </div>
      <div class="contents">
        <div class="currency_box">
          <curTitle color="#fff"
                    :data="{title:'我能为您做什么?',content:'围绕经营、管理、财税、战略四大体系全方位为零售企业提供整体解决方案'}"></curTitle>
        </div>
        <div class="currency_box"
             style="margin-top:20px">
          <DoWhat></DoWhat>
        </div>
      </div>
    </div>
    <!-- 五大亮点 -->
    <div class="Highlights_box">
      <div class="currency_box">
        <curTitle color="#000"
                  :data="{title:'五大服务',content:'新零售实体门店 · 一站式解决方案'}"></curTitle>
      </div>
      <div class="currency_box"
           style="margin-top:20px">
        <Highlights></Highlights>
      </div>
    </div>
    <!-- 合作企业 -->
    <div class="cooperation_box">
      <div class="currency_box">
        <curTitle color="#333"
                  :data="{title:'强劲实力 客户信赖之选',content:numberList[0].num+ '年专注零售实体企业，助力10000+企业实现转型升级'}"></curTitle>
      </div>
      <div class="logo_box">
        <div class="left_bg">
        </div>
        <div class="right_bg"></div>
        <div class="currency_boxs">
          <div class="picList_box">
            <div class="picList">
              <div class="picItem"
                   v-for="item in 76"
                   :key="item+'i'"
                   @mouseenter="mouseover(item)">
                <div class="logoImg_box">
                  <el-image class="logoImg"
                            :style="{'transform':logoIndex==item?'scale(1.3)':''}"
                            :src="item<10?$imgUrl + 'home/logo/0' + item +'.png':$imgUrl + 'home/logo/' + item +'.png'"
                            alt=""
                            srcset=""></el-image>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="currency_box"
           style="padding-top:20px">
        <el-carousel indicator-position="outside"
                     style="width:100%"
                     arrow="never"
                     :autoplay="false"
                     height="590px">
          <el-carousel-item v-for="item in 1"
                            :key="item">
            <div style="padding:20px 0;box-sizing: border-box;">
              <div v-for="x in 30"
                   class="iconItem"
                   :key="'i'+x">
                <el-image style="width:100%;height:100%"
                          :src="x<10?$imgUrl + 'home/logo/0' + x +'.png':$imgUrl + 'home/logo/' + x +'.png'"
                          alt=""
                          srcset=""></el-image>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div> -->
      <div class="currency_box">
        <div style="color:#fff;text-align: center;width: 100%;">部分合作企业，排名不分先后</div>
      </div>
    </div>
    <!-- 优秀讲师 -->
    <div class="lecturer_box">
      <div class="currency_box">
        <curTitle color="#333"
                  :data="{title:'行业内外 资深讲师团队',content:'为零售企业量身定制持续增长方案+创造新的核心竞争力'}"></curTitle>
      </div>
      <div class="currency_box"
           style="margin-top:20px">
        <lecturer></lecturer>
      </div>
    </div>
    <login :dialogVisible="dialogVisible"
           @close="closelogin"></login>
  </div>
</template>
<script>
import Number from '@/components/number.vue'
import curTitle from '@/components/home/cur_title.vue'
import DoWhat from '@/components/home/DoWhat.vue'
import Highlights from '@/components/home/Highlights.vue'
import lecturer from '@/components/home/lecturer.vue'
import CountTo from 'vue-count-to'
import {
  resourceList
} from '../api/api.js'
export default {
  components: {
    CountTo,
    Number,
    curTitle,
    DoWhat,
    Highlights,
    lecturer
  },
  data () {
    return {
      initialIndex: 0,
      bg: '#474d59',
      logoIndex: -1,
      swiperList: [], //轮播图
      videoUrl: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4',
      numberList: [{ num: 11, text: '专注零售商超行业' }, { num: '10000', text: '零售商超企业共同选择' }, { num: 100, text: '行业内外资深一线实战专家' }],
      dialogVisible: false,
      tabList: [],
      tabIndex: 0,
      tabId: "",
      value: '',
      list: [], //首页推荐数据
      listShow: false,
      navBg: '',
      data: {
        showIndex: 1,
        pageNumber: 1,
        pageSize: 100
      }
    }
  },
  created () {
    this.numberList[0].num = new Date().getFullYear() - 2011;
  },
  watch: {
    initialIndex (newData, oldData) {
      if (newData == 0) {
        this.bg = '#474d5b';
      } else if (newData == 1) {
        this.bg = '#0042c4';
      }
    }
  },
  mounted () {
    window.addEventListener('scroll', this.handleScroll) // 监听页面滚动
    this.getresourceList()
  },
  methods: {
    initialIndexChange (index) {
      console.log(index);
      this.initialIndex = index;
    },
    mouseover (index) {
      this.logoIndex = index;
    },
    // link (item) {
    //   console.log(item)
    // },
    async getresourceList () {  //获取首页资源
      const res = await resourceList(this.data)
      console.log(res)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      this.swiperList = res.data;
    },
    handleScroll () {
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop > 1) {
        this.navBg = 'rgba(255,255,255,1)'
      } else {
        this.navBg = ''
      }
    }
  }
}
</script>
<style lang="less">
// .filterGray{
//   filter: grayscale(100%)
//   //FILTER: grey;
// }
.home {
  // overflow-x: hidden;
  position: relative;
  .iconItem:nth-child(6n + 6) {
    margin-right: 0;
    margin-bottom: 24px;
  }
  .iconItem:hover {
    bottom: 12px;
  }
  .iconItem {
    cursor: pointer;
    transition: all 6s ease-in-out;
    display: inline-block;
    width: calc((100% - 120px) / 6);
    height: 90px;
    background-color: #fff;
    margin-right: 24px;
    margin-bottom: 24px;
    padding: 10px 20px;
    box-sizing: border-box;
    position: relative;
  }
  .lecturer_box {
    width: 100%;
    margin-bottom: 40px;
    padding-top: 50px;
  }
  .doWhat_box {
    min-width: 1200px;
    height: 850px;
    display: flex;
    justify-content: center;
    // font-size: 0;
    // background-image: url('http://wechatapppro-1252524126.file.myqcloud.com/crm/image/jpeg/l8e8s93q05cz.jpg');
    // background-size: 100% 100%;
    // background-repeat: no-repeat;
    position: relative;
    box-sizing: border-box;
    .video {
      // background: #222;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      z-index: 1;
      object-fit: fill;
      // display: none;
    }
    .contents {
      position: absolute;
      padding-top: 100px;
      box-sizing: border-box;
      z-index: 2;
      left: 0;
      width: 100%;
      background: rgba(0, 0, 0, 0.3);
      // background-color: #fff;
      top: 0;
      height: 100%;
    }
    // opacity: 0.8;
    .totalList {
      position: absolute;
      z-index: 12;
      top: -50px;
      left: 0;
      height: 100px;
      width: 100%;
      .totalbox {
        height: 100%;
        border-radius: 10px;
        background-color: #fff;
        padding: 20px 0;
        box-sizing: border-box;
        .total_item {
          flex: 1;
          text-align: center;
          border-right: 1px solid #eee;
          font-size: 20px;
          .num {
            color: red;
            font-size: 40px;
            font-family: 'bb';
          }
        }
      }
    }
  }
  .Highlights_box {
    min-width: 1200px;
    // height: 628px;
    padding-top: 50px;
    background: #fff;
  }
  .cooperation_box {
    min-width: 1200px;
    // height: 830px;
    padding: 40px 0;
    background-color: #fff;
    .logo_box {
      width: 100%;
      position: relative;
      .left_bg {
        position: absolute;
        left: 0;
        top: 0;
        width: 36%;
        height: 100%;
        background: url('https://www.dtyunxi.com/images/index_fgh11.png')
          no-repeat right center;
        background-size: cover;
        z-index: 5;
      }
      .right_bg {
        position: absolute;
        right: 0;
        top: 0;
        width: 36%;
        height: 100%;
        background: url('https://www.dtyunxi.com/images/index_fgh12.png')
          no-repeat left center;
        background-size: cover;
        z-index: 5;
      }
    }
    .picList_box {
      margin-top: 40px;
      width: 100%;
      background-color: #f6f6f6;
      padding: 15px 0 0 15px;
      // box-shadow: 2px 2px 2px 1px rgba(0, 0, 0, 0.2);
      overflow: hidden;
      .picList {
        width: 400%;
        // left: -100px;
        // flex-wrap: wrap;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-wrap: wrap;
        // box-shadow: 10px;
        visibility: visible;
        animation-duration: 2s;
        animation-delay: 0.2s;
        animation: scroll 40s linear infinite; /*滚动动画*/
        .picItem {
          // float: left;
          // display: inline-block;
          width: calc((100% - 234px) / 19);
          height: 130px;
          // padding: 30px 0;
          box-sizing: border-box;
          background-color: #fff;
          color: #000;
          text-align: center;
          margin-right: 11px;
          margin-bottom: 11px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 21px 0;
          box-sizing: border-box;
          cursor: pointer;
          .logoImg_box {
            overflow: hidden;
            .logoImg {
              width: 100%;
              height: 100%;
              transition: all 3s;
            }
          }
          // animation: scroll 20s linear infinite; /*滚动动画*/
        }
        .picitem:nth-child(19n) {
          margin-right: 0;
        }
      }
      .picList:hover {
        -webkit-animation-play-state: paused;
        animation-play-state: paused;
      }
      @keyframes scroll {
        from {
          transform: translateX(0); /*div多宽就写多宽*/
        }

        to {
          transform: translateX(-75%);
        }
      }
    }
    // .el-carousel__item h3 {
    //   color: #475669;
    //   font-size: 18px;
    //   opacity: 0.75;
    //   line-height: 300px;
    //   margin: 0;
    // }

    // .el-carousel__item:nth-child(2n) {
    //   background-color: #99a9bf;
    // }

    // .el-carousel__item:nth-child(2n + 1) {
    //   background-color: #d3dce6;
    // }
  }
  .swpier {
    width: 1200px;
    height: 450px;
    font-size: 0;
    .video {
      width: 100%;
      height: 450px;
      background-color: #000;
    }
  }
}
</style>
